import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";
import { initTelemetry } from "./lib/telemetry";
import { initSentry } from "./lib/sentry";
import { hasAnalyticsConsent } from "./lib/cookieConsent";
import { initGoogleAnalytics } from "./lib/googleAnalytics";

// Error tracking runs on legitimate interest (no cookies). Analytics telemetry
// (Application Insights and Google Analytics 4 both set cookies) loads only once
// the visitor has accepted — the CookieBanner initialises it on accept; here we
// honour a returning visitor.
initSentry();
if (hasAnalyticsConsent()) {
  initTelemetry();
  initGoogleAnalytics();
}

// Single light theme — no dark mode (matches the logged-in platform).
document.documentElement.classList.remove("dark");

// Marketing site is public — no ClerkProvider (the app subdomain handles auth).
const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Marketing root element was not found");
}

createRoot(rootElement).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>,
);
